// extracted by mini-css-extract-plugin
export default {"divider":"XEKb26","expanded":"Mp4x5_"};